import RegisterForm from '../../components/Auth/RegisterForm';
import Footer from '../../components/Layout/Footer';
import Navbar from '../../components/Layout/Navbar';
import PageMeta from '../../components/pagesHelmet/PageMeta';

export default function RegisterPage() {
  return (
    <>
    <PageMeta title="Sign Up | U2LR URL Shortener" />
      <Navbar />
        <div className="auth-page">
          <RegisterForm />
        </div>
      <Footer />
    </>
  );
}